import { render } from "./EditCDCSensorModal.vue?vue&type=template&id=3c238683&scoped=true"
import script from "./EditCDCSensorModal.vue?vue&type=script&lang=js"
export * from "./EditCDCSensorModal.vue?vue&type=script&lang=js"

import "./EditCDCSensorModal.vue?vue&type=style&index=0&id=3c238683&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c238683"]])

export default __exports__